/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    cafeMenuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    cafeMenuBranchNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    cafeSubscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    applyValue?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    applyUnit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest
     */
    useCafeFlag: boolean;
}

export function JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cafeMenuNo': !exists(json, 'cafeMenuNo') ? undefined : json['cafeMenuNo'],
        'cafeMenuBranchNo': !exists(json, 'cafeMenuBranchNo') ? undefined : json['cafeMenuBranchNo'],
        'cafeSubscriptionId': !exists(json, 'cafeSubscription_id') ? undefined : json['cafeSubscription_id'],
        'applyValue': !exists(json, 'applyValue') ? undefined : json['applyValue'],
        'applyUnit': !exists(json, 'applyUnit') ? undefined : json['applyUnit'],
        'useCafeFlag': json['useCafeFlag'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cafeMenuNo': value.cafeMenuNo,
        'cafeMenuBranchNo': value.cafeMenuBranchNo,
        'cafeSubscription_id': value.cafeSubscriptionId,
        'applyValue': value.applyValue,
        'applyUnit': value.applyUnit,
        'useCafeFlag': value.useCafeFlag,
    };
}

